import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Button, TextField, Grid, Box, Typography, Paper, Alert } from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import PhoneIcon from "@mui/icons-material/Phone";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [success, setSuccess] = useState(false);

  const onSubmit = async (data) => {
    try {
      const response = await axios.post("https://sirius.runasp.net/api/Message", {
        firstName: data.firstName,
        lastName: data.lastName,
        emailAddress: data.email,
        content: data.message,
      });

      if (response.status === 200) {
        // Handle successful submission
        setSuccess(true);
        reset(); // Clear the form inputs
        setTimeout(() => setSuccess(false), 5000); // Remove the success message after 5 seconds
      }
    } catch (error) {
      // Handle errors
      console.error("There was an error sending the message!", error);
      alert("Failed to send the message. Please try again later.");
    }
  };

  return (
    <Box sx={{ p: "50px 5rem" }}>
      {/* Contact Information */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xm={6} sm={6} lg={4}>
          <Paper
            sx={{
              display: "flex",
              alignItems: "center",
              p: 3,
              border: "1px solid #ddd",
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            <MailIcon sx={{ color: "#e84545", fontSize: 30, mr: 1 }} />
            <Typography variant="body1">SiriusEG@hotmail.com
            </Typography>
          </Paper>
        </Grid>
        <Grid item xm={6} sm={6} lg={4}>
          <Paper
            sx={{
              display: "flex",
              alignItems: "center",
              p: 3,
              border: "1px solid #ddd",
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            <PhoneIcon sx={{ color: "#e84545", fontSize: 30, mr: 1 }} />
            <Typography variant="body1">+201097764628
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Success Message */}
      {success && (
        <Alert
          severity="success"
          icon={<CheckCircleIcon fontSize="inherit" />}
          sx={{ mb: 4 }}
        >
          Message sent successfully!
        </Alert>
      )}

      {/* Contact Form */}
      <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ mt: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="First name"
              variant="outlined"
              fullWidth
              {...register("firstName", { required: "First name is required" })}
              error={Boolean(errors.firstName)}
              helperText={errors.firstName?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Last name"
              variant="outlined"
              fullWidth
              {...register("lastName", { required: "Last name is required" })}
              error={Boolean(errors.lastName)}
              helperText={errors.lastName?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email address"
              type="email"
              variant="outlined"
              fullWidth
              {...register("email", { required: "Email address is required" })}
              error={Boolean(errors.email)}
              helperText={errors.email?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Message"
              variant="outlined"
              fullWidth
              multiline
              rows={5}
              {...register("message", { required: "Message is required" })}
              error={Boolean(errors.message)}
              helperText={errors.message?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 2, backgroundColor: "#e84545", color: "#fff" }}
            >
              Send Message
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ContactForm;
